import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
} from '../../VoiceAssistanceStyle';
import { CalendarOutlined, PlusCircleOutlined } from '@ant-design/icons';
import VSLoaderJson from '../../../../json/AppealLetter.json';

const VAAppealLetterLoader = (props) => {
	const { action } = props;
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								{action === 're_generate_appeal_letter'
									? 'Re-generating the appeal letter.'
									: 'Generating the appeal letter.'}
								<br />
								<span>
									{action === 're_generate_appeal_letter'
										? 'Re-generating...'
										: 'Generating...'}
								</span>
							</XThemeVoiceAssTitle>
						</Col>
						{/* <Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={24} className="text-center">
											<XThemeVSGenerateAL>
												<XVSLottie
													className="relativePositions"
													animationData={VSLoaderJson}
													loop={true}
												/>
											</XThemeVSGenerateAL>
										</Col>
									</Row>
								</div>
							</XThemeVoiceAssTableCard>
						</Col> */}
						<Col
							xs={{ span: 12, offset: 6 }}
							className="text-center"
						>
							<img
								className="img-fluid"
								src="/images/generate-appeal-letter.png"
								alt=""
							/>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAAppealLetterLoader;
